import NaviTable from '@cp/src/components/NaviTable/NaviTable';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import { useState, useMemo } from 'react';
import Modal from '@cp/src/components/Modal/Modal';
import { getCumulativeAllocationDetailsColumnDefs } from './CumulativeAllocationDetails';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { getAllocationSummary, triggerAllocation } from './action';
import { CollectionType, AllocationTriggerType } from './consts';

const FailedAllocationDetails = () => {
  const dispatch = useDispatch();

  const failureMetadata = useSelector(
    (state: RootState) => state.allocations?.summaryData?.failureMeta
  );
  const allocationConfigName = useSelector(
    (state: RootState) => state.allocations?.summaryData?.configName
  );

  const failedAllocationRows = useMemo(
    () => (failureMetadata ? [failureMetadata] : []),
    [failureMetadata]
  );

  const [isModalOpen, setIsModalOpen] = useState(false);

  const businessVertical = useSelector((state: RootState) => state.common?.agentBusinessVertical);

  const handleOnModalClose = () => {
    setIsModalOpen(false);
  };

  const handleRetriggerClick = () => {
    setIsModalOpen(true);
  };

  const handleConfirmRetriggerClick = () => {
    const payload = {
      configName: allocationConfigName,
      businessVertical,
      collectionType: CollectionType.TELE,
      allocationTriggerType: AllocationTriggerType.ACTUAL
    };
    dispatch(
      triggerAllocation(payload, () => {
        dispatch(getAllocationSummary(allocationConfigName, CollectionType.TELE));
      })
    );
    setIsModalOpen(false);
  };

  const FAILED_ALLOCATIONS_TABLE = getCumulativeAllocationDetailsColumnDefs(handleRetriggerClick);

  return (
    <div className="p-0 m-[20px]">
      <Typography className="mt-6 mb-4" variant="h3" color={'var(--navi-color-gray-c2)'}>
        Failed Allocation details
      </Typography>
      <div className="h-[128px]">
        <NaviTable
          data={failedAllocationRows || []}
          columns={FAILED_ALLOCATIONS_TABLE}
          totalElements={failedAllocationRows?.length}
          showPaginationComponent={false}
        />
        <Modal visible={isModalOpen} onClose={handleOnModalClose} showCloseIcon={false}>
          <>
            <div className="w-[395px] rounded-lg mb-10 flex flex-col text-left">
              <Typography variant="h3" color="var(--navi-color-gray-c1)">
                Are you sure you want to retrigger allocations?
              </Typography>
            </div>
            <div className="flex flex-row items-center mb-2 justify-between gap-4">
              <Button
                variant="secondary"
                size="large"
                onClick={handleOnModalClose}
                className="w-full"
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                size="large"
                onClick={handleConfirmRetriggerClick}
                className="w-full"
              >
                Confirm
              </Button>
            </div>
          </>
        </Modal>
      </div>
    </div>
  );
};

export default FailedAllocationDetails;
